var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.16683 3H2.62979C2.28599 3 1.95628 3.13657 1.71317 3.37968C1.47007 3.62278 1.3335 3.9525 1.3335 4.2963V13.3704C1.3335 13.7142 1.47007 14.0439 1.71317 14.287C1.95628 14.5301 2.28599 14.6667 2.62979 14.6667H11.7039C12.0477 14.6667 12.3774 14.5301 12.6205 14.287C12.8636 14.0439 13.0002 13.7142 13.0002 13.3704V8.83333",
    stroke: "#272932",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3159 1.73633C12.5742 1.47809 12.9244 1.33301 13.2896 1.33301C13.6548 1.33301 14.0051 1.47809 14.2633 1.73633C14.5216 1.99457 14.6667 2.34482 14.6667 2.71003C14.6667 3.07524 14.5216 3.4255 14.2633 3.68374L8.09655 9.85054L5.82338 10.4188C5.6769 10.4554 5.54423 10.3228 5.58085 10.1763L6.14914 7.90313L12.3159 1.73633Z",
    stroke: "#272932",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 8L8 9",
    stroke: "#272932",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.65846e5e851a7ae6c023d2efd257a80d.svg";
export { ForwardRef as ReactComponent };